import { put, call, takeLatest } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as enterpriseService from '../../services/enterpriseService';
import * as uberService from '../../services/uberService';

function* createUberVoucher(options) {
  try {
    const response = yield call(uberService.createUberVoucher, options.phoneNumber, options.claimId);
    if (response.errors) {
      yield put(actions.createUberVoucherFailed(response.errors));
    } else {
      yield put(actions.createUberVoucherSuccess());
    }
  } catch (error) {
    yield put(actions.createUberVoucherFailed(error));
  }
}

function* createEnterpriseRental(options) {
  try {
    const { claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress } = options;
    yield call(enterpriseService.createEnterpriseRental, claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress);
    yield put(actions.createEnterpriseRentalSuccess());
  } catch (error) {
    yield put(actions.createEnterpriseRentalFailed(error));
  }
}

function* enterpriseLocations(options) {
  try {
    const { searchCriteria } = options;
    const response = yield call(enterpriseService.searchEnterpriseLocations, searchCriteria);
    yield put(actions.searchEnterpriseLocationsSuccess(response.data));
  } catch (error) {
    yield put(actions.searchEnterpriseLocationsFailed(error));
  }
}

function* audatargetVendor(options) {
  try {
    const { searchCriteria } = options;
    const response = yield call(enterpriseService.searchAudatargetVendor, searchCriteria);
    yield put(actions.searchAudatargetVendorSuccess(response.data));
  } catch (error) {
    yield put(actions.searchAudatargetVendorFailed(error));
  }
}

function* audatargetAvailibility(options) {
  try {
    const { searchCriteria } = options;
    const response = yield call(enterpriseService.audatargetGetAvailibility, searchCriteria);
    yield put(actions.audatargetGetAvailibilitySuccess(response.data));
  } catch (error) {
    yield put(actions.audatargetGetAvailibilityFailed(error));
  }
}

function* audatargetBookAppointment(options) {
  try {
    const { searchCriteria } = options;
    const response = yield call(enterpriseService.audatargetBookAppointment, searchCriteria);
    yield put(actions.audatargetBookAppointmentSuccess(response.data));
  } catch (error) {
    yield put(actions.audatargetBookAppointmentFailed(error));
  }
}

export default function* saga() {
  yield takeLatest(actionTypes.CREATE_UBER_VOUCHER, createUberVoucher);
  yield takeLatest(actionTypes.CREATE_RENTAL, createEnterpriseRental);
  yield takeLatest(actionTypes.ENTERPRISE_SEARCH_LOCATIONS, enterpriseLocations);
  yield takeLatest(actionTypes.AUDATARGET_SEARCH_VENDOR, audatargetVendor);
  yield takeLatest(actionTypes.AUDATARGET_GET_AVAILABILITY, audatargetAvailibility);
  yield takeLatest(actionTypes.AUDATARGET_BOOK_APPOINTMENT, audatargetBookAppointment);
}
